import { useEffect, useRef } from 'react';

/**
 * 版本检查 Hook - 检测应用更新并自动刷新页面
 * @param {number} checkInterval - 检查间隔时间（毫秒），默认 30000ms（30秒）
 */
export const useVersionCheck = (checkInterval = 30000) => {
  const lastVersionRef = useRef(null);
  const hasCheckedRef = useRef(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // 添加时间戳防止缓存
        const response = await fetch(`/version.json?t=${Date.now()}`);
        if (!response.ok) throw new Error('Failed to fetch version');

        const data = await response.json();
        const currentVersion = data.version;

        // 首次检查时保存版本
        if (!hasCheckedRef.current) {
          lastVersionRef.current = currentVersion;
          hasCheckedRef.current = true;
          return;
        }

        // 比较版本，如果不同则刷新
        if (lastVersionRef.current && lastVersionRef.current !== currentVersion) {
          console.log(
            `检测到新版本: ${lastVersionRef.current} -> ${currentVersion}，正在刷新...`
          );
          // 给用户 2 秒时间看到提示信息
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } catch (error) {
        console.error('版本检查失败:', error);
      }
    };

    // 立即执行一次
    checkVersion();

    // 定期检查
    const interval = setInterval(checkVersion, checkInterval);

    return () => clearInterval(interval);
  }, [checkInterval]);
};
